import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import { ChangePasswordPath, ProfilePath } from './urls';

const UserProfile = lazyWithReload(() =>
  import('./pages/UserProfile').then((m) => ({ default: m.Container }))
);

const ChangePasswordView = lazyWithReload(() =>
  import('./pages/ChangePassword').then((m) => ({ default: m.ChangePassword }))
);

export const ProfileRoute = (
  <>
    <Route path={ProfilePath} element={<UserProfile />} />
    <Route path={ChangePasswordPath} element={<ChangePasswordView />} />
  </>
);

export default ProfileRoute;
